import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useModalWorkTagStore } from '../../shared/store/workTagStore';
import { useWorkTag } from '../../shared/hooks/useApi/useWorkTag';
import { WorkTagData } from '../../shared/dto/EntityRepository';
import { usePageOwnerIdentityStore } from '../../shared/store/pageOwnerIdentityStore';
import { canShowWorkTagList } from '../../shared/util/visibility/workTagVisibility';

/** ImportStationWorks / WorkList PDF 모달용 — 페이지 WorkTag store를 공유. 목록 stale은 canShow로 억제. */
const ImportTagStation: React.FC = () => {
  const {
    tags,
    listOwnerAui,
    status,
    getWorkTagList,
  } = useWorkTag();
  const {
    selectedModalTags,
    addSelectedModalTag,
    removeSelectedModalTag,
    clearSelectedModalTags,
  } = useModalWorkTagStore();
  const pageOwner = usePageOwnerIdentityStore((s) => s.pageOwner);
  const canShowTags = canShowWorkTagList({
    pageOwnerAui: pageOwner?.aui,
    listOwnerAui,
    status,
  });
  const visibleTags = canShowTags ? tags : [];

  useEffect(() => {
    clearSelectedModalTags();
    void getWorkTagList();
  }, []);

  const handleSelectTag = (tag: WorkTagData) => {
    if (selectedModalTags.some((t) => t.id === tag.id)) {
      removeSelectedModalTag(tag);
    } else {
      addSelectedModalTag(tag);
    }
  };

  if (visibleTags.length === 0) return null;

  return (
    <TagContainer>
      {visibleTags.map((tag) => (
        <TagItem
          key={tag.id}
          $isActive={selectedModalTags.some((t) => t.id === tag.id)}
          onClick={() => handleSelectTag(tag)}
        >
          {tag.name}
        </TagItem>
      ))}
    </TagContainer>
  );
};

const TagContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 4px 0;
  gap: 4px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.color_Gray_05};
  ${({ theme }) => theme.typography.Body_04};
`;

const TagItem = styled.div<{ $isActive: boolean }>`
  cursor: pointer;
  width: fit-content;
  border-bottom: 1px dotted
    ${({ $isActive, theme }) => ($isActive ? theme.colors.color_Gray_03 : 'transparent')};
  color: ${({ $isActive, theme }) => ($isActive ? theme.colors.color_Gray_03 : theme.colors.color_Gray_04)};
  opacity: ${({ $isActive }) => ($isActive ? 1 : 0.5)};
  &:hover {
    transform: scale(0.95);
  }
  transition: all 0.3s ease-in-out;
`;

export default ImportTagStation;
